import type { PendingMetric } from '@fleetcore/shared'
import { useTranslation } from 'react-i18next'

/**
 * The wording a gauge shows instead of a number it does not have.
 *
 * Same resolution order as <MetricTile />: the metric's own reason key wins when
 * the catalog knows it, so "Données CAN non disponibles pour ce véhicule" can
 * replace the generic "Non disponible sur ce véhicule" on an RPM dial — one of
 * those sentences tells an installer what to check and the other does not.
 *
 * The map below duplicates the one inside metric-tile.tsx. That file belongs to
 * another agent this phase; see NOTES-PHASE2-DETAIL.md §5 for the hoist.
 */
const AVAILABILITY_KEYS: Record<PendingMetric['availability'], string> = {
  pending_telemetry: 'common:metric.pendingTelemetry',
  not_supported_by_vehicle: 'common:metric.notSupported',
  insufficient_history: 'common:metric.insufficientHistory',
}

export function usePendingLabel(): (metric: PendingMetric) => string {
  const { t, i18n } = useTranslation()

  return (metric: PendingMetric) => {
    if (metric.reasonKey && i18n.exists(metric.reasonKey)) return t(metric.reasonKey)
    return t(AVAILABILITY_KEYS[metric.availability])
  }
}
